module.exports = __webpack_public_path__ + "img/security.7b0b14ef.svg";